document.addEventListener("DOMContentLoaded", () => {
    const links = document.querySelectorAll("[data-wheel-brand-selector] .wheel-brand-link");
    if (!links.length) return;
  
    const currentHandle = window.location.pathname.split("/").pop();
    const storedHandle = localStorage.getItem("selectedWheelBrand");
  
    // Remove all actives
    links.forEach(link => link.classList.remove("active"));
  
    let matched = false;
  
    // Match by URL
    links.forEach(link => {
      const handle = link.getAttribute("data-url");
      if (handle === currentHandle) {
        link.classList.add("active");
        matched = true;
      }
    });
  
    // Fallback to stored
    if (!matched && storedHandle) {
      links.forEach(link => {
        if (link.getAttribute("data-url") === storedHandle) {
          link.classList.add("active");
        }
      });
    }
  
    // Store selected brand
    links.forEach(link => {
      link.addEventListener("click", () => {
        localStorage.setItem("selectedWheelBrand", link.getAttribute("data-url"));
      });
    });
  });
  